export default __webpack_public_path__ + "static/media/sendGreen.c79df898.svg";